import React, { useEffect, useState } from "react";
import WSSS from "../../assets/images/web-solution.png";
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceSide from "./ServiceSide";
import Web from "../../assets/service/web-solutions.png";
import BgImg from "../../assets/images/bg5.jpg";
import { Helmet } from "react-helmet-async";
// import { ChevronDown } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faWarehouse,
  faChartLine,
  faBoxes,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import OurClients from "../OurClients/OurClients";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
function WebSolutionServices() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const faqData = [
    {
      question: "How a well-designed website helps my business?",
      answer:
        "A well-designed website helps in enhances your business's visibility, credibility, and accessibility. It helps in lead generation, Brand recognition, marketing, customer service, informative, social existence of your business, It allows customers to access your products, services, and information 24/7, with a direct point of contact and making it essential for long-term business success and efficiency.",
    },
    {
      question:
        "Is there any difference between web designing and web development?",
      answer:
        "Yes, off course, Web designing mainly focuses on the look and appearance of a website. It includes creating the layout, structure, and overall visual appearance of a website including choosing colors, fonts, images, and ensuring user-friendly navigation. whereas web development involves the coding and functionality that make a website work.",
    },
    {
      question: "How can web solutions help digital marketing?",
      answer:
        "Web solutions support digital marketing by offering tools and services like SEO, content management, online advertising, and social media integration to attract and engage organic traffic.",
    },
    {
      question: "Can I have a custom website?",
      answer:
        "Yes, you can have a custom website which is designed specifically as per your business requirements, providing a unique look, features, and functionality that align with your brand, unlike generic templates",
    },
    {
      question: "How much time does it take to develop a website?",
      answer:
        "The time required to develop a website depends on its complexity. Simple websites may take a few weeks, while more complex sites or e-commerce platforms could take several months.",
    },
    {
      question: "How can I secure my website?",
      answer:
        "The security of your website depends on various factors such as using secure hosting, installing SSL certificates, regular software updates, and protecting against common threats like malware and hackers.",
    },
    {
      question: "Designing and maintaining a website is costly?",
      answer:
        "The cost of building a website depends on the type of website (e.g., business website, e-commerce site, blog) and the complexity of the features required. Costs includes web designing, developing, hosting, and ongoing maintenance. We at Deetya soft provides you best website solution at very affordable price.",
    },
    {
      question: "I have more queries, how can I contact you?",
      answer:
        "Please Feel free to Call us: +91 9015350505 or sign up at www.deetyasoft.com or write us at accounts@deetyasoft.com. We will provide you end-to-end support to get your website.",
    },
  ];

  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === faqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(faqData.map((_, i) => i));
    }
  };

  const pillars = [
    {
      icon: faWarehouse,
      title: "Inventory Management",
      description:
        "Inventory management is all about what, where, and how much inventory is available.",
      bgColor: "bg-green-100",
    },
    {
      icon: faChartLine,
      title: "Performance Analytics",
      description:
        "Get real-time analytics and performance metrics for better decision-making.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faBoxes,
      title: "Product Management",
      description:
        "Manage your products efficiently with streamlined processes.",
      bgColor: "bg-purple-100",
    },
    {
      icon: faClipboardList,
      title: "Task Management",
      description:
        "Organize tasks effectively to boost productivity and collaboration.",
      bgColor: "bg-orange-100",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Website Solution Services - Custom & Professional | Deetyasoft
        </title>
        <meta
          name="description"
          content="Get customized web solutions suitable to your business, design responsive, user-friendly websites that boost engagement, user experience & conversions."
        />
        <meta
          name="keywords"
          content="Website Solutions, Website Designc, professional website design, website design and development, web solution services, responsive web design, eCommerce web development, mobile-friendly website, online business solutions, secure web development, web application development, cloud-based web solutions, CMS development services, dynamic website  "
        />
        <link rel="canonical" href="https://deetyasoft.com/web-solution" />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/web-solution" />
        <meta
          property="og:title"
          content="Website Solution Services - Custom & Professional | Deetyasoft"
        />
        <meta
          property="og:description"
          content="Get customized web solutions suitable to your business, design responsive, user-friendly websites that boost engagement, user experience & conversions."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/web-solution.d8bd095ef105260e41cd.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/web-solution"
        />
        <meta
          name="twitter:title"
          content="Website Solution Services - Custom & Professional | Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Get customized web solutions suitable to your business, design responsive, user-friendly websites that boost engagement, user experience & conversions."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/web-solution.d8bd095ef105260e41cd.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta
          name="google-site-verification"
          content="RfVxHwAy-Zv_s_VZjaK7Dyqb84AGXX7y8MdkaGLItD4"
        />
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        <script type="application/ld+json">
          {`
        {
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Deetya Soft Pvt Ltd",
          "description": "Get customized web solutions suitable to your business, design responsive, user-friendly websites that boost engagement, user experience & conversions.",
          "image": "https://www.deetyasoft.com/static/media/web-solution.d8bd095ef105260e41cd.png",
          "logo": "https://www.deetyasoft.com/images/logo.png",
          "url": "https://www.deetyasoft.com",
          "telephone": ["+91-9015350505", "+91-9717055088"],
          "email": "info@deetyasoft.com",
          "sameAs": [
            "https://www.linkedin.com/company/deetya-soft-private-limited",
            "https://www.facebook.com/deetyasoftprivatelimited",
            "https://www.instagram.com/deetyasoft",
            "https://www.youtube.com/@deetyasoft",
            "https://www.crunchbase.com/organization/deetyasoft"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
            "addressLocality": "Ghaziabad",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201014",
            "addressCountry": "IN"
          }
        }
        `}
        </script>

        {/* Contact Schema */}
        <script type="application/ld+json">
          {`
        {
          "@context": "http://schema.org",
          "@type": "Organization",
          "url": "https://www.deetyasoft.com",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-981-862-7588",
              "contactType": "technical support",
              "areaServed": "IN"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+91-901-535-0505",
              "contactType": "sales",
              "areaServed": "IN"
            }
          ]
        }
        `}
        </script>

        {/* Review Schema */}
        <script type="application/ld+json">
          {`
        {
          "@context": "http://schema.org",
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Parshan "
          },
          "reviewBody": "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
          "url": "https://www.deetyasoft.com/",
          "description": "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
          "datePublished": "2025-06-17",
          "name": "Deetya Soft Pvt Ltd",
          "reviewRating": {
            "@type": "Rating",
            "worstRating": "1",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "itemReviewed": {
            "@type": "Organization",
            "name": "Deetya Soft Pvt Ltd"
          }
        }
        `}
        </script>

        {/* Fixed FAQ Schema */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How a well-designed website helps my business?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "A well-designed website helps in enhances your business's visibility, credibility, and accessibility. It helps in lead generation, Brand recognition, marketing, customer service, informative, social existence of your business, It allows customers to access your products, services, and information 24/7, with a direct point of contact and making it essential for long-term business success and efficiency."
              }
            },
            {
              "@type": "Question",
              "name": "Is there any difference between web designing and web development?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, off course, Web designing mainly focuses on the look and appearance of a website. It includes creating the layout, structure, and overall visual appearance of a website including choosing colors, fonts, images, and ensuring user-friendly navigation. whereas web development involves the coding and functionality that make a website work."
              }
            },
            {
              "@type": "Question",
              "name": "How can web solutions help digital marketing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Web solutions support digital marketing by offering tools and services like SEO, content management, online advertising, and social media integration to attract and engage organic traffic."
              }
            },
            {
              "@type": "Question",
              "name": "Can I have a custom website?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, you can have a custom website which is designed specifically as per your business requirements, providing a unique look, features, and functionality that align with your brand, unlike generic templates."
              }
            },
            {
              "@type": "Question",
              "name": "How much time does it take to develop a website?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The time required to develop a website depends on its complexity. Simple websites may take a few weeks, while more complex sites or e-commerce platforms could take several months."
              }
            },
            {
              "@type": "Question",
              "name": "How can I secure my website?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The security of your website depends on various factors such as using secure hosting, installing SSL certificates, regular software updates, and protecting against common threats like malware and hackers."
              }
            },
            {
              "@type": "Question",
              "name": "Designing and maintaining a website is costly?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The cost of building a website depends on the type of website (e.g., business website, e-commerce site, blog) and the complexity of the features required. Costs includes web designing, developing, hosting, and ongoing maintenance. We at Deetya soft provides you best website solution at very affordable price."
              }
            },
            {
              "@type": "Question",
              "name": "I have more queries, how can I contact you?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Please Feel free to Call us: +91 9015350505 or sign up at www.deetyasoft.com or write us at accounts@deetyasoft.com. We will provide you end-to-end support to get your website."
              }
            }
          ]
        }
        `}
        </script>
      </Helmet>
      <div>
        {/* heroo section */}

        <div className="relative bg-[#2f68a2] overflow-hidden  pb-7 text-white">
          {/* Content */}
          <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
            {/* Left Side */}
            <div>
              <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
                Web Solution Services
              </h1>
              <p className="text-white/90 mb-6 text:base md:text-lg">
                Are you planning to create your own website? Share your vision
                with us, or take control and build it yourself using our
                powerful Project Maker software. Whether you need a personal
                blog, a stunning portfolio, or a full-fledged business site,
                we've got the tools to make it happen. Start building your dream
                website today and bring your ideas to life!
              </p>

              <button
                className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
                onClick={() => {
                  const target = document.getElementById("bottomTarget");
                  if (target) {
                    target.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                    // Optional offset tweak using window.scrollBy
                    setTimeout(() => {
                      window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                    }, 600);
                  }
                }}
              >
                Let's Get Started
              </button>
            </div>

            {/* Right Side Image */}
            <div className="flex justify-center">
              <img
                src={WSSS}
                alt="SEO Illustration"
                className="md:w-[90%] object-contain  w-full max-w-lg animate-float"
              />
            </div>
          </div>

          {/* FIRST CURVE - White */}
          <div className="absolute bottom-0 left-0 w-full z-10">
            <svg
              className="w-full h-auto"
              viewBox="0 0 1440 290"
              preserveAspectRatio="none"
            >
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              />
            </svg>
          </div>

          {/* SECOND CURVE - Light Blue */}
          <div className="absolute bottom-[20px] left-0 w-full z-0">
            <svg
              className="w-full h-auto"
              viewBox="0 0 1440 320"
              preserveAspectRatio="none"
            >
              <path
                fill="#a6c7e2" // Light blue like in the image
                fillOpacity="1"
                d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              />
            </svg>
          </div>
        </div>

        {/* second web solution section */}
        <div className="">
          <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center  mb-2 text-gray-600">
            Web Solution Services
          </h2>
          <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

          <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
            Streamline your stock, reduce costs, and ensure products are always
            available when needed.
          </p>

          {/* Wrapper that allows scrolling */}
          <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
            {/* Main Content */}
            <div className="container mx-auto px-4 py-8">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
                {/* Image Section */}

                <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                  <img
                    src={Web}
                    alt="websolution-services"
                    className="w-full h-full  object-cover"
                  />
                </div>

                {/* Text Content Section */}

                <div className="space-y-3 md:text-base text-sm order-2 md:order-1 text-justify">
                  <h2 className="text-2xl font-semibold text-main md:text-2xl lg:text-3xl">
                    Strengthen Your Online Presence
                  </h2>

                  <p className="text-gray-700 leading-relaxed">
                    A website is an integral part of every business. It ensures
                    an online presence and allows customers to explore your
                    products and services 24/7. A well-crafted website gives
                    credibility to your business and allows access on a global
                    scale, removing geographical boundaries.
                  </p>

                  <p className="text-gray-700 leading-relaxed">
                    Your website is the foundation of your digital marketing
                    strategy. Customers can easily learn about your products,
                    services, pricing, location, business hours, place orders
                    online, and track their status in real-time. It is scalable
                    and grows alongside your business, making it easy to expand
                    services or enter new markets.
                  </p>

                  <p className="text-gray-700 leading-relaxed">
                    In today’s digital age, where people heavily rely on the
                    internet to find products and services, having a
                    professional and effective website is not optional—it's
                    essential for long-term growth and business success.
                  </p>

                  <h2 className="text-2xl font-semibold text-main md:text-2xl lg:text-3xl my-2">
                    Comprehensive Web Solutions
                  </h2>

                  <p className="text-gray-700 leading-relaxed">
                    At <strong>Deetya Soft</strong>, we specialize in dynamic
                    web solutions that support your business growth and online
                    visibility. Our core services include:
                  </p>

                  <ul className="list-disc pl-5 space-y-1 text-gray-700">
                    <li>
                      <strong>Web Designing & Development:</strong> Creating
                      visually appealing and functional websites that engage
                      visitors.
                    </li>
                    <li>
                      <strong>Content Management Systems (CMS):</strong> Easily
                      manage and update website content without technical
                      hassle.
                    </li>
                    <li>
                      <strong>Web Portal Development:</strong> Develop
                      user-friendly and interactive portals for seamless
                      engagement.
                    </li>
                    <li>
                      <strong>Web Analytics & Monitoring:</strong> Analyze user
                      behavior and optimize your website for better performance.
                    </li>
                    <li>
                      <strong>Cloud Solutions:</strong> Utilize cloud
                      technologies for scalable and secure operations.
                    </li>
                    <li>
                      <strong>Web Application Development:</strong> Build custom
                      web apps tailored to your business needs.
                    </li>
                  </ul>

                  <p className="text-gray-700 leading-relaxed">
                    As internet activity continues to rise, having a solid web
                    development strategy becomes the gateway to your business
                    success. <strong>Deetya Soft</strong> stands out as a
                    trusted name when it comes to web design and development.
                  </p>

                  <h2 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl my-3">
                    Enhance Your Digital Reach
                  </h2>

                  <p className="text-gray-700 leading-relaxed">
                    Along with web development, we offer a complete suite of
                    digital services to promote your business and brand
                    effectively:
                  </p>

                  <ul className="list-disc pl-5 space-y-1 text-gray-700">
                    <li>
                      <strong>SEO Services:</strong> Improve your rankings and
                      gain visibility through search engine optimization.
                    </li>
                    <li>
                      <strong>Hosting Services:</strong> Secure and reliable
                      hosting solutions for uninterrupted service.
                    </li>
                    <li>
                      <strong>Domain Booking Services:</strong> Find and
                      register the right domain name that reflects your brand.
                    </li>
                    <li>
                      <strong>Internet Marketing:</strong> Expand your brand
                      reach through strategic digital marketing techniques.
                    </li>
                  </ul>

                  <p className="text-gray-700 leading-relaxed">
                    We focus on understanding your specific business needs and
                    delivering tailored solutions that maximize your online
                    potential. As technology evolves and users become more
                    tech-savvy, maintaining a strong web presence becomes vital
                    for branding and publicity.
                  </p>

                  <p className="text-gray-700 leading-relaxed">
                    When you're ready to take your business online,{" "}
                    <strong>Deetya Soft</strong> is here to meet all your
                    website development and internet marketing needs.
                  </p>
                </div>
              </div>
            </div>
            {/* Sticky Sidebar */}
            <div className="sticky  top-20 self-start  p-3  h-fit">
              <ServiceSide />
            </div>
          </div>

          {/* make it next section */}
        </div>
        <div
          className="py-5 px-5 relative"
          // data-aos='fade-up'
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "repeat",
            backgroundSize: "auto",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            minHeight: "60vh",
          }}
        >
          <div className="text-center py-10 px-4">
            <h2 className="text-3xl md:text-4xl font-semibold">
              <span className="text-white">Our Power Packed </span>
              <span className="text-sky-500"> Feature</span>
            </h2>

            <div className="relative w-fit mx-auto mt-2">
              <div className="h-[1px] bg-gray-300 md:w-[200px] w-[100px] mx-auto"></div>
              <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
                <div className="w-8 h-[2px] bg-sky-500"></div>
                <div className="w-8 h-[2px] bg-sky-500"></div>
              </div>
            </div>

            <p className="text-gray-300 text-base mt-4">
              What You Get Using Our Inventory Management System
            </p>
          </div>

          <div className="container mx-auto px-4 pb-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="p-8 text-center">
                    <div
                      className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                    >
                      <FontAwesomeIcon
                        icon={pillar.icon}
                        className="text-sky-500 text-2xl"
                      />
                    </div>
                    <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                      {pillar.title}
                    </h5>
                    <p className="text-gray-600 text-sm">
                      {pillar.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* benifits section */}

        {/* faq section */}

        <div id="bottomTarget" className="bg-gray-100 py-8">
          <div className="max-w-5xl mx-auto px-4 py-12">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row items-center sm:justify-between mb-8 gap-4">
              <div className="text-center sm:text-left w-full sm:w-auto">
                <h2 className="text-2xl md:text-3xl font-semibold text-main1">
                  Frequently Asked Questions (FAQ)
                </h2>
                <div className="w-20 md:w-40 mx-auto sm:mx-0 border-b-4 border-main1 rounded-full mt-2" />
              </div>

              <button
                onClick={toggleAll}
                className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap"
              >
                {openIndexes.length === faqData.length
                  ? "Collapse all"
                  : "Expand all"}
              </button>
            </div>

            {/* FAQ List */}
            <div className="space-y-4">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-sm overflow-hidden"
                >
                  <button
                    onClick={() => toggleItem(index)}
                    className="w-full flex justify-between items-center px-6 py-4 text-left hover:bg-gray-50 transition-colors"
                  >
                    <p className="text-base md:text-lg font-medium text-black">
                      {item.question}
                    </p>
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className={`w-4 h-4 transform transition-transform ${
                        openIndexes.includes(index) ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {openIndexes.includes(index) && (
                    <div className="px-6 pb-4 text-gray-700 text-sm md:text-base">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* client section */}
        <div>
          <OurClients />
        </div>
      </div>
    </>
  );
}

export default WebSolutionServices;
